import React from 'react';
import PropTypes from 'prop-types';
import './SkeletonLoader.css';

/**
 * Base skeleton loader component that renders an animated placeholder shape.
 * Used as a building block for view-specific skeleton variants.
 *
 * @param {Object} props
 * @param {string} [props.width] - CSS width value (e.g. '100%', '200px')
 * @param {string} [props.height] - CSS height value (e.g. '16px', '200px')
 * @param {string} [props.borderRadius] - CSS border-radius (defaults to var(--radius-sm))
 * @param {string} [props.className] - Additional CSS class names
 */
const SkeletonLoader = ({ width, height, borderRadius = 'var(--radius-sm)', className }) => (
  <div className={`skeleton ${className || ''}`} style={{ width, height, borderRadius }} aria-hidden="true" />
);

SkeletonLoader.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  borderRadius: PropTypes.string,
  className: PropTypes.string,
};

export default SkeletonLoader;
